module.exports = __webpack_public_path__ + "img/clock-desk.0620dea2.svg";